/*
by zhang.qiang 2017/03/08
 */
"use strict";
angular.module('manageSysManageAddcomLibraryManagementModule', [])
    .controller('manageSysManageAddComLibraryManagementCtrl', ['$scope', '$modalInstance', 'Params', 'trsHttpService', 'modalDialog', function($scope, $modalInstance, Params, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = angular.copy(Params);
            $scope.title = Params.APPMODULEID == "0" ? "新建" : "修改";
            $scope.isShowLabel = true;
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {

        }
        /**
         * [checkRepeatName 检查重名称]
         * @return {[type]} [true为重复 false为不重复]
         */
        $scope.checkRepeatName = function() {
            var params = {
                serviceid: "mlf_appmodule",
                methodname: "uniqueModuleName",
                ModuleName: $scope.status.MODULENAME
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.isShowLabel = data.slice(1,-1);
            });
        };
        /**
         * [cancel 取消]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.isShowLabel == "false") {
                modalDialog.alertType('组件名称重复', "", "warning", false);
                return;
            }
            $modalInstance.close($scope.status);
        };
    }]);
